export let json = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "@id": "https://www.seguroviagem.srv.br/article",
  "name": "Seguro Viagem para os EUA",
  "description": "Contrate um Seguro Viagem para os EUA com Cobertura Covid e 15% de Desconto - Garantimos o Melhor preço e 12 Vezes Sem Juros. Clique e Economize."
}
